import { useLocale } from "@i18n/react";
import { useQueryClient } from "@tanstack/react-query";

import { displayTypeEnum } from "../../../lib/types/enums/displayTypeEnum";
import type { UseRequestMutationProps } from "../../../request/hooks/useRequestMutation";
import { useRequestMutation } from "../../../request/hooks/useRequestMutation";
import { keyFavorites } from "../favorites/keyFavorites";
import { keyHome } from "../home/keyHome";
import { keyPrayer } from "../prayer/keyPrayer";

export type UseRequestFavoriteProps = UseRequestMutationProps & {
  id: number;
};

export const useRequestFavorite = ({
  id,
  ...props
}: UseRequestFavoriteProps) => {
  const locale = useLocale();
  const queryClient = useQueryClient();

  return {
    mutationPost: useRequestMutation({
      ...props,
      mutationFnRequestProps: {
        urlBackendPath: `/prayers/${id}/favorite`,
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [keyHome(), locale] });
        queryClient.invalidateQueries({
          queryKey: [keyPrayer({ id }), locale],
        });

        displayTypeEnum.options.forEach((displayTypeEnumOption) =>
          queryClient.invalidateQueries({
            queryKey: [
              keyFavorites({ displayType: displayTypeEnumOption }),
              locale,
            ],
          }),
        );
      },
    }),
  };
};
